import styled from 'styled-components';
import { Button } from 'antd';

export const BuyButton = styled(Button)`
  flex: 1;
  height: 32px;
  border: none;
  border-radius: 4px;
  color: white;
  font-size: 12px;
  font-weight: 500;
  background-color: #fa8c16;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  &:hover {
    background-color: #e67e22;
  }

    @media (max-width: 450px) {
    min-width: 32px;
    padding: 0 8px;
  }
`;
